export const UIComponentErrorCodes = {
  MISSING_CONTEXT: "MISSING_CONTEXT",
} as const;

export const UIComponentErrorMessages = {
  [UIComponentErrorCodes.MISSING_CONTEXT]: (
    componentName: string,
    requiredContext: string,
  ): string =>
    `${componentName} must be used within a <${requiredContext}> component. ` +
    `Ensure the component is wrapped in <${requiredContext}>.`,
} as const;

export const FormComponentNames = {
  USE_FORM_FIELD: "useFormField",
  FORM_FIELD: "FormField",
  FORM_ITEM: "FormItem",
} as const;

export const UnderlineTabsComponentNames = {
  UNDERLINE_TABS: "UnderlineTabs",
  UNDERLINE_TABS_LIST: "UnderlineTabsList",
  UNDERLINE_TABS_TRIGGER: "UnderlineTabsTrigger",
  UNDERLINE_TABS_CONTENT: "UnderlineTabsContent",
} as const;

export const DateUtilsErrorMessages = {
  TIMEZONE_OFFSET_NOT_FOUND: (timezone: string): string =>
    `Could not determine timezone offset for "${timezone}".`,
} as const;
